import React from "react";

const AgenciesList = ({ children, className }) => {
  return (
    <div
      className={`agencies-list overflow-y-scroll relative ${className}`}
      style={{ height: 650 }}
      dir="ltr"
    >
      {children}
    </div>
  );
};

export default AgenciesList;
